import React from 'react';
import { QUERY_KEYS, soCaiColumns, thanhToanPhaiThuColumns, theKhoColumns, thueVatDauRaColumns } from '@/constants';
import { InfoDropdownV2, type InfoTableItem } from '@/components/custom/erp';

interface InfoDropdownProps {
  uuid: string;
  ma_ct?: string;
  className?: string;
}

export const InfoDropdown = ({ uuid, ma_ct, className }: InfoDropdownProps) => {
  const tableItems: InfoTableItem[] = [
    {
      title: 'Xem sổ kho mua/bán hàng',
      endpoint: QUERY_KEYS.SO_KHO,
      columns: theKhoColumns,
      group: 1,
      visibleFields: [
        'loai_kho',
        'xid',
        'ma_unit',
        'so_ct',
        'ngay_ct',
        'ma_kho',
        'ma_vt',
        'ten_vt',
        'ma_kh',
        'ma_nt',
        'px_dd',
        'pn_tb',
        'gia',
        'sl_xuat',
        'tien_xuat',
        'thue',
        'ma_nvbh',
        'ten_nvbh',
        'tien2',
        'ma_ct'
      ]
    },
    {
      title: 'Xem sổ cái',
      endpoint: QUERY_KEYS.SO_CAI,
      columns: soCaiColumns,
      group: 1
    },
    {
      title: 'Thanh toán phải thu',
      endpoint: QUERY_KEYS.THANH_TOAN_PHAI_THU,
      columns: thanhToanPhaiThuColumns,
      group: 1
    },
    {
      title: 'Thuế VAT đầu ra',
      endpoint: QUERY_KEYS.THUE_VAT_DAU_RA,
      columns: thueVatDauRaColumns,
      group: 1
    }
  ];

  return <InfoDropdownV2 uuid={uuid} ma_ct={ma_ct} tableItems={tableItems} className={className} />;
};

export default InfoDropdown;
